import * as React from "react"

function IconBrakes(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      {...props}
    >
      <title>{"Brakes"}</title>
      <g fill="none" fillRule="evenodd">
        <path
          d="M47 30c0 9.389-7.611 17-17 17s-17-7.611-17-17 7.611-17 17-17c1.779 0 3.494.273 5.106.78l-2.28 7.24A9.416 9.416 0 0139.412 30h0z"
          stroke="#E3E833"
          strokeWidth={2}
        />
        <path
          d="M50 30H39.412h0a9.416 9.416 0 00-6.586-8.98l3.18-10.102C44.118 13.468 50 21.048 50 30z"
          stroke="#E3E833"
          strokeWidth={2}
        />
        <circle stroke="#E3E833" strokeWidth={2} cx={30} cy={30} r={4} />
      </g>
    </svg>
  )
}

export default IconBrakes
